const WISTIA_SCRIPT_EL_ID = 'wistia-script-el-id';

export default {
  initialize() {
    if (!this.wistiaScriptIsAdded()) {
      // for adding custom options and plugins
      // wistia API takes the 'window._wq' array
      // for more details
      // see https://wistia.com/support/developers/embed-options#setting-options-on-standard-and-popover-embeds
      this._wq = window._wq || [];

      // Need to load E-v1.js for the Wistia JavaScript Player API
      const script = document.createElement('script');
      script.setAttribute('id', WISTIA_SCRIPT_EL_ID);
      script.async = true;
      script.src = '//fast.wistia.net/assets/external/E-v1.js';
      document.head.appendChild(script);
    }
  },

  wistiaScriptIsAdded() {
    return document.getElementById(WISTIA_SCRIPT_EL_ID) !== null;
  },

  /**
   * Adds custom embed options and plugins to wistia videos
   * @see https://wistia.com/support/developers/embed-options
   */
  addCustomConfiguration(customConfiguration) {
    if (!this._wq || !this._wq.push) return;

    this._wq.push(customConfiguration);
  },
};
